//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { IntegracoesContext } from "../../context/IntegracoesContext";
import { deleteIntegrationService, loadIntegrationsService } from "../../services";
import { LoadingContext } from "../../../../shared/context/LoadingContext"



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function ModalDeleteIntegration() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { integrations, setIntegrations } = useContext(IntegracoesContext); // Estado que armazena a lista de Tags
    const { isOpenModalDeleteIntegration, setIsOpenModalDeleteIntegration } = useContext(IntegracoesContext);
    const { formDataModalDeleteIntegration, setFormDataModalDeleteIntegration } = useContext(IntegracoesContext); // Estado que armazena se Tag deve ser deletada
    const { isLoading, setIsLoading } = useContext(LoadingContext);


    //--------- FUNÇÃO ASSÍNCRONA CONFIRMAR DELEÇÃO --------//
    // Nesta função, é deletada a Tag selecionada do Banco de Dados via API.
    const handleConfirmDelete = async () => {
        const response = await deleteIntegrationService(formDataModalDeleteIntegration.integration.id);
        if (response) {
            setFormDataModalDeleteIntegration(null);
            setIsOpenModalDeleteIntegration(false);
            handleRefreshIntegrations();
        }
    };



    //-------- FUNÇÃO ASSÍNCRONA CARREGAR TAGS ----------//
    // Nesta função, é requisitado à API as INTEGRAÇÕES armazenadas.
    // AS INTEGRAÇÕES retornadas pela API são armazenadas no Estado "integrations" .
    async function handleRefreshIntegrations() {
        setIsLoading(true);
        const response = await loadIntegrationsService();
        if (response) {
            setIntegrations(response.data);
        }
        setIsLoading(false);
    };



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* DIV DE CONFIRMAÇÃO DE EXCLUSÃO DE TAG */}
            {!isOpenModalDeleteIntegration
                ? null
                :
                <>
                    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
                        <div className="bg-surface-1 border border-white/[0.08] rounded-xl p-6 w-full max-w-md">
                            <h2 className="text-xl font-bold mb-4">Confirmação</h2>
                            <p className="mb-4">Você tem certeza de que deseja remover esta integração?</p>
                            <div className="bg-blue-600 text-sm text-white p-3 rounded mb-4">
                                <strong>Atenção!</strong><br />
                                Esta ação não pode ser desfeita! Ao clicar em "SIM", a integração será removida permanentemente.
                            </div>
                            <div className="flex justify-end gap-3">
                                <button
                                    onClick={() => {
                                        setFormDataModalDeleteIntegration(null);
                                        setIsOpenModalDeleteIntegration(false);
                                    }}
                                    className="px-4 py-2 bg-surface-3 hover:bg-surface-4 rounded"
                                >
                                    NÃO
                                </button>
                                <button
                                    onClick={handleConfirmDelete}
                                    className="px-4 py-2 bg-brand-600 hover:bg-brand-700 rounded"
                                >
                                    SIM
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            }

        </>
    )
}